import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_PPMU_MULTIPLE_PRICES_EXPERIMENT = defineFcm('revenue_ppmu_multiple_prices_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
				amounts: {
					type: 'array',
					shape: { type: 'number' },
				},
				maxSliderAmount: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'PPMU',
		description:
			'This flag enables the multiple prices experiment on PPMU Modal. It also defines the experiment name and the different amounts to be tested. Configure amounts in normal currency units, not in base units (e.g., for $5, use 5 instead of 500 for cents).',
		import: false,
		template: {
			enabled: true,
			experimentName: 'exp_revenue_ppmu_multiple_prices_experiment_v1',
			amounts: [4, 5, 6],
			maxSliderAmount: 10,
		},
	});
